import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';

const AutocompleteContext = /*#__PURE__*/React.createContext(null);
/**
 * Provides the AutocompleteContext to its children.
 *
 * @template OptionType - The type of the options in the ListBox. Defaults to `ListBoxOptionType`.
 *
 * @param props - The properties for the AutocompleteContextProvider component.
 * @param props.children - The child components that will have access to the Autocomplete context.
 * @param props.otherProps - The other properties that will be passed to the Autocomplete context.
 *
 * @returns The AutocompleteContext.Provider component.
 */
function AutocompleteContextProvider(props) {
  const {
      children
    } = props,
    otherProps = __rest(props, ["children"]);
  const value = React.useMemo(() => otherProps, Object.values(otherProps));
  return /*#__PURE__*/React.createElement(AutocompleteContext.Provider, {
    value: value
  }, children);
}
/**
 * Custom hook to use the AutocompleteContext provided by `AutocompleteContextProvider`.
 *
 * @returns A hook to use the AutocompleteContext.
 */
function useAutocompleteContext() {
  return React.useContext(AutocompleteContext);
}

export { AutocompleteContextProvider, useAutocompleteContext };
